export type Drama = {
  id: string;
  title: string;
  poster: string;
  genres: string[];
  year: number;
  episodes: number;
  currentEp: number;
  score: number;
  status: string;
  tags: string[];
  synopsis: string;
  exclusive: boolean;
  viewers: number;
  updateDate: string;
  updateNote: string;
};

const statusStyle: Record<string, string> = {
  热播中: "bg-primary-500 text-background-50",
  最新更新: "bg-accent-500 text-foreground-950",
  已完结: "bg-secondary-600 text-background-50",
};

export default function DramaCard({ drama }: { drama: Drama }) {
  return (
    <article className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/80 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title}（${drama.year}）韩剧海报`}
          title={`${drama.title} 韩剧 高清海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-label font-medium ${
            statusStyle[drama.status] ?? "bg-foreground-800 text-background-50"
          }`}
        >
          {drama.status}
        </span>
        {drama.exclusive ? (
          <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md text-xs font-label font-medium bg-background-50/95 text-primary-700">
            独播
          </span>
        ) : null}
        <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md text-xs font-label font-bold bg-foreground-950/75 text-accent-300">
          {drama.score.toFixed(1)}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 truncate">
          {drama.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-2 text-xs font-label text-foreground-600">
          <span>{drama.year}</span>
          <span className="text-foreground-300">·</span>
          <span>共{drama.episodes}集</span>
          <span className="text-foreground-300">·</span>
          <span>{drama.genres.join(" / ")}</span>
        </div>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {drama.synopsis}
        </p>
        <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between gap-3">
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-700">
            <i className="ri-refresh-line text-sm" aria-hidden="true" />
            {drama.updateNote}
          </span>
          <span className="inline-flex items-center gap-1 text-xs font-label text-foreground-500 whitespace-nowrap">
            <i className="ri-fire-line text-sm text-accent-600" aria-hidden="true" />
            {drama.viewers}万
          </span>
        </div>
      </div>
    </article>
  );
}